const localeData = require("./locales-data") as {
  DEFAULT_LOCALE: "en"
  SUPPORTED_LOCALES: readonly string[]
}

export const DEFAULT_LOCALE = localeData.DEFAULT_LOCALE

export type SupportedLocale =
  | "en"
  | "pt"
  | "es"
  | "fr"
  | "de"
  | "ar"
  | "it"
  | "ja"
  | "ko"
  | "nl"
  | "pl"
  | "ru"
  | "th"
  | "vi"
  | "zh"

export const SUPPORTED_LOCALES = localeData.SUPPORTED_LOCALES as readonly SupportedLocale[]

export const isSupportedLocale = (value: string | null | undefined): value is SupportedLocale =>
  !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value)

export const getPreferredLocale = (value: string | null | undefined): SupportedLocale =>
  isSupportedLocale(value) ? value : DEFAULT_LOCALE
